import {
  Color,
  InstancedMesh,
  Matrix4,
  MeshStandardMaterial,
  Quaternion,
  SphereGeometry,
  Vector3,
} from "three";
import type { Catalogue } from "../../data/schema";
import type { FrameData } from "../frame";
import type { Tier } from "./tier";
import { colorAttribute } from "./colors";

const m = new Matrix4(),
  p = new Vector3(),
  q = new Quaternion(),
  s = new Vector3();

export class InstancedTier implements Tier {
  readonly object: InstancedMesh;

  constructor(
    bodies: Catalogue,
    private readonly indices: number[],
  ) {
    this.object = new InstancedMesh(
      new SphereGeometry(1, 16, 12),
      new MeshStandardMaterial({ roughness: 1 }),
      indices.length,
    );
    const colors = colorAttribute(bodies, indices);
    const c = new Color();
    indices.forEach((_, k) =>
      this.object.setColorAt(k, c.setRGB(colors[3 * k], colors[3 * k + 1], colors[3 * k + 2])),
    );
    this.object.frustumCulled = false;
  }

  update(frame: FrameData): void {
    const { positions, radii, rotations } = frame;
    this.indices.forEach((index, k) => {
      const o = 3 * index,
        r = 4 * index;
      p.set(positions[o], positions[o + 1], positions[o + 2]);
      q.set(rotations[r], rotations[r + 1], rotations[r + 2], rotations[r + 3]);
      s.setScalar(frame.visible[index] ? radii[index] : 0);
      this.object.setMatrixAt(k, m.compose(p, q, s));
    });
    this.object.instanceMatrix.needsUpdate = true;
  }
}
